import { LegacyStack } from '@shopify/polaris';
import { useState, useEffect } from 'react';
import DropdownButton from '../Common/DropdownButton';
import { PDFModal } from '../Modals/PDFModal';

const ViewLossesPrimaryActions = ({ depositId, depositName }) => {
  const [activePDFModal, setActivePDFModal] = useState(false);
  const [queryPDF, setQueryPDF] = useState({});

  // Recompone la query con los filtros de la URL + depositId si aplica.
  const buildQuery = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const q = {};
    for (const [key, value] of urlParams) q[key] = value;
    delete q['r'];
    if (depositId) q.depositId = depositId;
    return q;
  };

  useEffect(() => {
    setQueryPDF(buildQuery());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [depositId]);

  const handlePDFExport = () => {
    setQueryPDF(buildQuery());
    setActivePDFModal(true);
  };

  const dropdownItems = [
    {
      content: 'Exportar a PDF',
      disabled: false,
      onAction: handlePDFExport,
    },
  ];

  return (
    <LegacyStack>
      <DropdownButton title={'Exportar'} items={dropdownItems} buttonProps={{}} />
      <PDFModal
        active={activePDFModal}
        onClose={() => setActivePDFModal(false)}
        domain={'deposits'}
        model={'losses'}
        query={queryPDF}
        title={depositName ? `PÉRDIDAS — ${depositName.toUpperCase()}` : 'PÉRDIDAS Y APARICIONES'}
        availableTemplates={['list']}
      />
    </LegacyStack>
  );
};

export default ViewLossesPrimaryActions;
